<div class="filter-container">
  <mat-button-toggle-group
    [disabled]="false"
    class="toggle-group-deep-style"
    [(ngModel)]="filterStatus"
    (change)="onStatusFilterChanged($event)"
  >
    <mat-button-toggle [value]="'all'" [matTooltip]="'All'"> All </mat-button-toggle>
    <mat-button-toggle [value]="statusTypes.valid.value" matTooltip="{{ JobStatusToIcon[JobStatus.Ready].label }}">
      <div class="aligner">
        <y42-job-status [jobStatus]="JobStatus.Ready" class="job-status-icon"></y42-job-status>
        <span>{{ statusTypes.valid.count }}</span>
      </div>
    </mat-button-toggle>
    <mat-button-toggle [value]="statusTypes.invalid.value" matTooltip="{{ JobStatusToIcon[JobStatus.Invalid].label }}">
      <div class="aligner">
        <y42-job-status [jobStatus]="JobStatus.Invalid" class="job-status-icon"></y42-job-status>
        <span>{{ statusTypes.invalid.count }}</span>
      </div>
    </mat-button-toggle>
    <mat-button-toggle [value]="statusTypes.pending.value" matTooltip="{{ JobStatusToIcon[JobStatus.Pending].label }}">
      <div class="aligner">
        <y42-job-status [jobStatus]="JobStatus.Pending" class="job-status-icon"></y42-job-status>
        <span>{{ statusTypes.pending.count }}</span>
      </div>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
